import React from "react";
import clsx from "clsx";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import useStyles from "./styles";

interface IProps {
  lifetime: racehorse360.IHorseLifetime;
  rootClassName?: string;
  titleClassName?: string;
}

const LifetimeStats = (props: IProps) => {
  const { lifetime, rootClassName, titleClassName } = props;

  const classes = useStyles();

  const renderLifetime = () => {
    const { starts, wins, place, show } = lifetime;

    return [starts, wins, place, show].map((element, index) => (
      <span key={index} className={classes.lifeInfoItem}>
        {element || 0}
      </span>
    ));
  };

  return (
    <div className={clsx(rootClassName, classes.lifeInfo)}>
      <span
        className={clsx(
          titleClassName,
          classes.lifeInfoItem,
          classes.lifeInfoTitle
        )}
      >
        Life:
      </span>
      {renderLifetime()}
    </div>
  );
};

export default React.memo(LifetimeStats);
